import {IAction} from '../../interfaces/action';
import {
  SELECT_AREA_NAME,
  SELECT_MUNICIPALITY,
  DELETE_AREA_SHAPE
} from '../../constants/actions';

/**
 * Initial state
 */
const initialState = null;

/**
 * Handle the current selected area name
 */
export default function(
  state: string | null = initialState,
  action: IAction
): string | null {
  switch (action.type) {
    case SELECT_AREA_NAME:
      return action.areaName ? action.areaName : null;

    case SELECT_MUNICIPALITY:
      return initialState;

    case DELETE_AREA_SHAPE:
      return initialState;

    default:
      return state;
  }
}
